<template>
  <ProtocolPage title="FAQs" :content="pageData" />
</template>

<script>
import ProtocolPage from '@/components/ProtocolPage'
import { lang } from '@/locales'

import { enData } from './enData.js'
import { esData } from './esData.js'
import { itData } from './itData.js'
import { plData } from './plData.js'
import { ptData } from './ptData.js'

const dataMap = { en: enData, es: esData, it: itData, pl: plData, pt: ptData }

export default {
  name: 'FAQs',
  components: {
    ProtocolPage
  },
  computed: {
    pageData() {
      return dataMap[lang] || enData
    }
  }
}
</script>
